import { nativeJSBridge, nativeJSBridgeSync } from './nativeJSBridge'
import { IBridgeOptions } from './interface'
import formatParams from './util/formatParams'

interface IAccountInfo {
  /**
   * 资金账号及密码加密串
   *
   * @type {boolean}
   * @memberof IAccountInfoResponse
   * @example {'accountInfo': 'sdflsnx34dsfsdlf'}
   */
  accountInfo: boolean
}

interface IAccountInfoResponse {
  success?: (result: IAccountInfo) => void
  fail?: (result: IAccountInfo) => void
  complete?: (result: IAccountInfo) => void
}

/**
 * 获取资金账号及密码加密串
 *
 * @param {IBridgeOptions<IAccountInfoResponse>} {
 *   success,
 *   fail,
 *   complete
 * }
 */
function getFundAccountAndPasswordSync({
  success,
  fail,
  complete
}: IBridgeOptions<IAccountInfoResponse>) {
  const params = formatParams({
    funType: 'userInfo',
    funName: 'getFundAccountAndPassword'
  })
  const opts: IBridgeOptions = {
    method: 'winner.hsJsFunction',
    params,
    success,
    fail,
    complete
  }
  try {
    nativeJSBridgeSync(opts)
  } catch (error) {
    console.log('getFundAccountAndPasswordSync error: ', error)
  }
}

/**
 * 获取资金账号及密码加密串
 * 一个异步接口，支持 Promise 化使用
 *
 * @returns {Promise<IAccountInfoResponse>}
 */
function getFundAccountAndPassword(): Promise<IAccountInfoResponse> {
  const params = formatParams({
    funType: 'userInfo',
    funName: 'getFundAccountAndPassword'
  })
  const opts: IBridgeOptions = {
    method: 'winner.hsJsFunction',
    params
  }

  return nativeJSBridge(opts)
}

export { getFundAccountAndPassword, getFundAccountAndPasswordSync }
